import React from 'react'

import AuthService from '../../utilities/services/auth.service'

import { LoadingContainer } from '../LoadingContainer'
import { resolvePageLoaderBranding } from './pageLoaderBranding'

import logoMark from '../../assets/logo.svg'

import './pageLoadingContainer.scss'

function readActiveOrganization() {
  if (typeof AuthService.getOrg !== 'function') return null

  try {
    const organizations = AuthService.getOrg()
    return Array.isArray(organizations) ? organizations[0] || null : null
  } catch {
    return null
  }
}

/**
 * Full-page loading state.
 * When the signed-in organization has brand settings, the page behind the
 * loader is blurred and the organization logo sits in the spinner.
 * The compact seat-map spinner stays plain.
 */
export default function PageLoadingContainer({
  style = '',
  size = 'xl',
  fullscreen = false,
  organization,
  text = 'Loading...',
  message = 'Loading...',
}) {
  const branding =
    size === 'sm'
      ? null
      : resolvePageLoaderBranding(organization || readActiveOrganization())

  if (branding) {
    return (
      <div
        id="page-loading-container"
        className={`page-loading-container--tenant ${
          branding.tone === 'light' ? 'page-loading-container--light' : ''
        } ${fullscreen ? 'page-loading-container--fullscreen' : ''} ${style} ${size}`}
        style={{
          '--loader-accent': branding.primaryColor,
          '--on-brand': '#23262f',
        }}
        role="status"
        aria-label="Loading"
        aria-busy="true"
      >
        <div className="page-loading-container__glow" aria-hidden />

        <div className="page-loading-container__mark">
          <svg
            className="page-loading-container__ring"
            viewBox="0 0 120 120"
            aria-hidden
          >
            <circle
              cx="60"
              cy="60"
              r="55"
              fill="none"
              stroke="currentColor"
              strokeOpacity="0.18"
              strokeWidth="3"
            />
            <circle
              className="page-loading-container__ring-arc"
              cx="60"
              cy="60"
              r="55"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>
          <div className="page-loading-container__logo-disk">
            {branding.logoSrc ? (
              <img
                src={branding.logoSrc}
                alt={branding.name || ''}
                className="page-loading-container__logo"
              />
            ) : (
              <span className="page-loading-container__logo-fallback">
                {branding.name?.charAt(0) || 'B'}
              </span>
            )}
          </div>
        </div>

        <div className="page-loading-container__copy">
          {branding.name && (
            <div className="page-loading-container__name">{branding.name}</div>
          )}
          <div className="page-loading-container__message">{message}</div>
        </div>

        {branding.showBlockTicketsBranding && (
          <div className="page-loading-container__powered">
            <img src={logoMark} alt="Blocktickets" />
          </div>
        )}
      </div>
    )
  }

  return (
    <div
      id="page-loading-container"
      className={`${fullscreen ? 'page-loading-container--fullscreen' : ''} ${style} ${size}`}
    >
      <LoadingContainer>
        {size === 'xl' && <h1 className="loading-text">{text}</h1>}
      </LoadingContainer>
    </div>
  )
}
